/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addDependencies } from './dependenciesAdd.generated';
import { applyDependencies } from './dependenciesApply.generated';
import { divideDependencies } from './dependenciesDivide.generated';
import { isNaNDependencies } from './dependenciesIsNaN.generated';
import { multiplyDependencies } from './dependenciesMultiply.generated';
import { subtractDependencies } from './dependenciesSubtract.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createVarianceTransform } from '../../factoriesAny.js';
export var varianceTransformDependencies = {
  addDependencies: addDependencies,
  applyDependencies: applyDependencies,
  divideDependencies: divideDependencies,
  isNaNDependencies: isNaNDependencies,
  multiplyDependencies: multiplyDependencies,
  subtractDependencies: subtractDependencies,
  typedDependencies: typedDependencies,
  createVarianceTransform: createVarianceTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesVarianceTransform.generated.js
// module id = 1544
// module chunks = 0